import { initializeApp } from "firebase/app";
import {
  getAnalytics,
  logEvent as fbLogEvent,
  setUserProperties as fbSetUserProperties,
  setUserId as fbSetUserId,
  Analytics as FirebaseAnalytics,
} from "firebase/analytics";
import { getDeviceModel } from "./device";

const firebaseConfig = {
  apiKey: "AIzaSyATFAHVAUYBqqdBtjS2sOhlJcqWGy2VTd4",
  authDomain: "bp-platforms.firebaseapp.com",
  projectId: "bp-platforms",
  storageBucket: "bp-platforms.appspot.com",
  messagingSenderId: "732167945689",
  appId: "1:732167945689:web:2df835ad0459892bf26dc8",
  measurementId: "G-NEF68PTM7P",
};

export class Analytics {
  private static app: ReturnType<typeof initializeApp> | null = null;
  private static analytics: FirebaseAnalytics | null = null;

  private static ensureInitialized(): void {
    if (Analytics.app) return;
    try {
      Analytics.app = initializeApp(firebaseConfig);
      Analytics.analytics = getAnalytics(Analytics.app);
    } catch (err) {
      console.error('[Analytics] Firebase init failed:', err);
    }
  }

  private static bpClientID = "receiver_cast";
  private static deviceType = "tv";
  private static currentUserId: string | null = null;

  public static eventNames = {
    CAST_CONTEXT_READY: "cast_context_ready",
    CAST_CONTEXT_ERROR: "cast_context_error",
    CAST_SENDER_CONNECTED: "cast_sender_connected",
    CAST_SENDER_DISCONNECTED: "cast_sender_disconnected",
    CAST_SHUTDOWN: "cast_shutdown",
    CAST_VISIBILITY_CHANGED: "cast_visibility_changed",
    CAST_STANDBY_CHANGED: "cast_standby_changed",
    CAST_LOADED_DATA: "cast_loaded_data",
    CAST_BUFFERING: "cast_buffering",
    CAST_PLAYER_LOAD_COMPLETE: "cast_player_load_complete",
    CAST_REQUEST_EDIT_AUDIO_TRACKS: "cast_request_edit_audio_tracks",
    CAST_REQUEST_EDIT_TRACKS_INFO: "cast_request_edit_tracks_info",
    CAST_REQUEST_VOLUME_CHANGE: "cast_request_volume_change",
    CAST_SYSTEM_VOLUME_CHANGED: "cast_system_volume_changed",
    MEDIA_REPRODUCTION_ERROR: "media_reproduction_error",
    MEDIA_SEEK: "media_seek",
    PLAYER_PLAY: "player_play",
    PLAYER_PAUSE: "player_pause",
    PLAYER_MEDIA_ENDED: "player_media_ended",
    CAST_USER_CONNECTED: "cast_user_connected",
    CAST_STANDBY_DISPLAYED: "cast_standby_displayed",
    CAST_STARTING_DISPLAYED: "cast_starting_displayed",
  };

  public static logEvent(
    event: string,
    params: Record<string, any> = {}
  ): void {
    Analytics.ensureInitialized();
    if (!Analytics.analytics) return;

    const finalParams: Record<string, any> = {
      ...params,
      bp_client_id: this.bpClientID,
      device_type: this.deviceType,
    };

    if (this.currentUserId) {
      finalParams.user_id = this.currentUserId;
    }

    try {
      finalParams.cast_session_token = (
        window as any
      ).cast?.framework?.CastReceiverContext.getInstance().getApplicationData().sessionId;
    } catch {
      // Cast session ID not available yet
    }

    try {
      fbLogEvent(Analytics.analytics, event, finalParams);
    } catch (err) {
      console.error('[Analytics] logEvent failed:', err);
    }
  }

  public static setUserProperties(): void {
    Analytics.ensureInitialized();
    if (!Analytics.analytics) return;

    try {
      const props: Record<string, string> = {
        bp_client_id: this.bpClientID,
        device_type: this.deviceType,
        device_model: getDeviceModel(),
      };
      fbSetUserProperties(Analytics.analytics, props);
    } catch (err) {
      console.error('[Analytics] setUserProperties failed:', err);
    }
  }

  public static setUserId(userId: string): void {
    Analytics.ensureInitialized();
    if (!Analytics.analytics) return;

    this.currentUserId = userId;
    try {
      fbSetUserId(Analytics.analytics, userId);
    } catch (err) {
      console.error('[Analytics] setUserId failed:', err);
    }
  }
}

// Side-effect: set user properties at load time (wrapped in try-catch to avoid
// crashing the module chain if device detection or Firebase fails early).
try {
  Analytics.setUserProperties();
} catch (err) {
  console.error('[Analytics] Initial setUserProperties failed:', err);
}
